var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('nav-bar'),_c('div',{staticClass:"main-div"},[_c('router-view')],1),_c('footer-bar'),_c('floating-robot-link',{attrs:{"visible":_vm.hasAiRobotLink},on:{"click":_vm.openAiRobotLink}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }